import React from 'react'

function NopPreview() {
  return (
    <div className='text-blue-400'>No Preview</div>
  )
}

export default NopPreview